import { render, staticRenderFns } from "./playerscreen.vue?vue&type=template&id=e4119730&"
import script from "./playerscreen.vue?vue&type=script&lang=js&"
export * from "./playerscreen.vue?vue&type=script&lang=js&"
import style0 from "./playerscreen.vue?vue&type=style&index=0&id=e4119730&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports